import { FieldValues, Path, UseFormReturn } from 'react-hook-form';

import { toaster } from 'ui/Toaster';

// This hook is used to show form errors from an API response.
// It sets errors on the form and returns a boolean indicating if there were any errors.
// It also sets a fallback field to show non-field errors in one of the fields or
// generates a toast message if no fallback field is provided.
export const useFormErrors = <T extends FieldValues>(
  form: UseFormReturn<T>,
  options?: { fallbackField?: Path<T> }
) => ({
  showFormErrors: (errors: any) => {
    // Extract form error messages
    const formErrors = Object.keys(errors ?? {}).map((key) => [
      key,
      errors[key]?.message ?? errors[key],
    ]);
    // Set errors on the form, including non-field errors
    formErrors.forEach(([field, message]) => {
      if (field === 'non_field_errors') {
        if (options?.fallbackField) {
          form.setError(options.fallbackField, { message });
        } else {
          toaster.error({ description: message });
        }
      } else {
        form.setError(field, { message });
      }
    });
    // Return if there were any errors
    return formErrors.length > 0;
  },
});
